import LegalPageShell from "@/components/LegalPageShell";

const SECTIONS = [
  {
    number: 1,
    title: "Subscription Cancellation",
    bullets: [
      "You may cancel your subscription at any time.",
      "Your subscription will remain active until the end of the current billing cycle.",
      "No further charges will be applied after cancellation unless you renew your subscription.",
    ],
  },
  {
    number: 2,
    title: "Refund Policy",
    paragraphs: [
      "As RootLyst is a digital SaaS platform, subscription fees are generally non-refundable once the service has been activated.",
      "Refunds may be considered only in the following situations:",
    ],
    bullets: [
      "Duplicate or accidental payment.",
      "Payment deducted but subscription not activated.",
      "Technical failure preventing access to the platform due to our systems.",
      "Incorrect billing caused by RootLyst.",
    ],
  },
  {
    number: 3,
    title: "Non-Refundable Items",
    paragraphs: ["Refunds will not be provided for:"],
    bullets: [
      "Partial subscription periods.",
      "Unused subscription time.",
      "Change of mind after activation.",
      "AI credits or services already consumed.",
      "Custom development, onboarding, or training services (if applicable).",
    ],
  },
  {
    number: 4,
    title: "Refund Processing",
    paragraphs: ["If a refund is approved:"],
    bullets: ["It will be processed to the original payment method.", "Processing typically takes 5–7 business days, depending on your payment provider or bank."],
  },
  {
    number: 5,
    title: "How to Request a Refund",
    paragraphs: ["To request a refund, contact our support team with:"],
    bullets: ["Registered email address", "Transaction ID", "Payment date", "Reason for the request", "Email: contact@rootlyst.com"],
  },
  {
    number: 6,
    title: "Policy Changes",
    paragraphs: ["RootLyst may update this policy from time to time. The latest version will always be available on our website."],
  },
  {
    number: 7,
    title: "Contact Us",
    paragraphs: ["For any refund or cancellation queries, please contact:", "RootLyst Support", "Email: contact@rootlyst.com"],
  },
];

export default function RefundPolicyPage() {
  return (
    <LegalPageShell
      testId="refund-policy-page"
      title="Refund & Cancellation Policy"
      effectiveDate="16/07/2026"
      lastUpdated="16/07/2026"
      intro="This Refund & Cancellation Policy applies to all subscriptions and services offered by RootLyst, an AI-powered clinic management platform."
      sections={SECTIONS}
    />
  );
}
